import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Home from './pages/Home';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import Dashboard from './pages/Dashboard';
import OurPrograms from './pages/OurPrograms';
import AdminProgramsDashboard from './pages/AdminProgramsDashboard';
import AdminSetup from './pages/AdminSetup';
import MountainDetail from './pages/MountainDetail';
import './App.css';

function AppContent() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/programs" element={<OurPrograms />} />
      <Route path="/admin/setup" element={<AdminSetup />} />
      <Route path="/admin/programs" element={<AdminProgramsDashboard />} />
      <Route path="/mountain/:mountainKey" element={<MountainDetail />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
